import { resolveImageUrl } from "../context/AppSettingsContext";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]));

// Scontrino "Ritiro premio": QR grande + codice RP per chi non usa lo smartphone (stesso stile degli scontrini punti)
export function buildPickupReceiptHtml({ reservation: r, customer, settings, branch, autoPrint = false }) {
  const logo = resolveImageUrl(branch?.logo_url) || resolveImageUrl(settings?.logo_url);
  const primary = settings?.primary_color || "#E5383B";
  const qr = `https://api.qrserver.com/v1/create-qr-code/?size=420x420&margin=4&data=${encodeURIComponent(r.pickup_code || "")}`;
  const contrib = Number(r.contribution_eur || 0);
  return `<!doctype html><html lang="it"><head><meta charset="utf-8"><title>Ritiro premio ${esc(r.pickup_code)}</title>
<style>
  body{font-family:Arial,Helvetica,sans-serif;color:#111;margin:0;padding:12px;width:72mm;max-width:72mm}
  .c{text-align:center}.logo{max-height:48px;max-width:160px;margin:0 auto 6px;display:block}
  h1{font-size:15px;margin:4px 0 2px;color:${primary}} .sub{font-size:11px;color:#555}
  .box{border:2px dashed #999;border-radius:10px;padding:10px;margin:10px 0}
  .reward{font-size:16px;font-weight:700;margin:4px 0}
  .code{font-family:monospace;font-size:26px;font-weight:800;letter-spacing:3px;margin:6px 0}
  img.qr{width:58mm;height:58mm;display:block;margin:4px auto}
  table{width:100%;font-size:12px;border-collapse:collapse} td{padding:2px 0} td.r{text-align:right;font-weight:700}
  .hint{font-size:11px;color:#444;line-height:1.35;margin-top:8px}
  .foot{font-size:10px;color:#888;margin-top:10px}
  @media print { body{padding:0} @page { margin: 6mm } }
</style></head><body>
  <div class="c">${logo ? `<img class="logo" src="${esc(logo)}" alt="">` : ""}<h1>${esc(settings?.app_name || "Loyalty Club")}</h1><div class="sub">${esc(branch?.name || "")}${branch?.name ? " · " : ""}Buono ritiro premio</div></div>
  <div class="box c">
    <div class="reward">${esc(r.reward_name)}</div>
    <img class="qr" src="${qr}" alt="QR ${esc(r.pickup_code)}">
    <div class="code">${esc(r.pickup_code)}</div>
  </div>
  <table>
    <tr><td>Cliente</td><td class="r">${esc(customer?.name || r.customer_name || "")}</td></tr>
    <tr><td>Carta</td><td class="r">${esc(customer?.card_number || r.customer_card || "")}</td></tr>
    <tr><td>Punti alla consegna</td><td class="r">${esc(r.points_cost)} pt</td></tr>
    ${contrib > 0 ? `<tr><td>Contributo da pagare</td><td class="r">€ ${contrib.toFixed(2)}</td></tr>` : ""}
    <tr><td>Prenotato il</td><td class="r">${new Date(r.created_at).toLocaleDateString("it-IT")}</td></tr>
  </table>
  <div class="hint">Presenta questo buono in cassa: il personale inquadra il QR (o digita il codice), consegna il premio e annulla il buono. Vale <b>una sola volta</b>; i punti vengono scalati al momento della consegna.</div>
  <div class="foot c">Stampato il ${new Date().toLocaleString("it-IT")}</div>
  ${autoPrint ? "<script>window.onload=function(){setTimeout(function(){window.print()},300)}</script>" : ""}
</body></html>`;
}

export function openPickupPrintWindow(opts) {
  const w = window.open("", "_blank", "width=420,height=760");
  if (!w) return false;
  w.document.write(buildPickupReceiptHtml({ ...opts, autoPrint: true }));
  w.document.close();
  return true;
}
